import React from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
// material ui
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
// components
import WidgetBar from '../../../../builder/components/WidgetBar.js'
import Theme from '../../Theme.js';
// helpers
import { translate } from '../translations.js';

const useStyles = makeStyles({
  card: {
    marginBottom: '28px',
    boxShadow: Theme.cardBoxShadow,
    position: 'relative',
  },
  header: {
    backgroundColor: props => props.screen == 'desktop' ? Theme.bgColorDark : '#ffffff',
  },
  headerText: {
    fontSize: '1.3rem',
    textAlign: 'center',
  },
  middle: {
    flex: '1 1 auto',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    paddingLeft: '8px',
    paddingRight: '5px',
    '& .name': {
      minWidth: 0,
      fontSize: '13px',
      lineHeight: 1,
    },
    '& .date': {
      fontSize: '13px',
      lineHeight: 1,
      color: Theme.palette.text.secondary,
      marginTop: '5px',
    },
  },
  right: {
    flex: '0 0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& .failed': {
      color: Theme.palette.text.primary,
      fontSize: '.7rem',
      letterSpacing: '.02em',
      lineHeight: 1.5,
      textAlign: 'center',
      textTransform: 'uppercase',
      width: '50px',
    },
    '& .time': {
      fontSize: '1.3rem',
      lineHeight: 1,
    },
    '& .time-label': {
      color: Theme.palette.text.secondary,
      fontSize: '.6rem',
      letterSpacing: '.02em',
      lineHeight: 1,
      marginTop: '5px',
      textTransform: 'uppercase',
    },
  },
  roomImg: {
    maxWidth: '50px',
  },
  roomResults: {
    "&:last-child": {
      paddingBottom: "1rem",
    },
  },
});

export default function EventResults(props) {
  const { context, screen } = props;
  const classes = useStyles(props);
  const [showWidgetBar, setShowWidgetBar] = React.useState(false)
  const componentClasses = clsx({
    [classes.card] : true,
    "cardMobile" : screen == 'mobile' ? true : false,
  })
  let groupType;
  let language;
  if (window.mode == 'live') {
    groupType = window.groupType;
    language = window.language;
  } else {
    groupType = useSelector(state => state.groupType)
    language = useSelector(state => state.language);
  };

  const handleWidgetHover = (e) => {
    if (e.type == 'mouseenter') {
      setShowWidgetBar(true);
    } else if (e.type == 'mouseleave') {
      setShowWidgetBar(false);
    }
  }

  return (
    <>
    {groupType == 'multi' &&
      <Card className={componentClasses + ' event-results-widget'}
        onMouseEnter={window.mode == 'builder' ? handleWidgetHover : null} onMouseLeave={window.mode == 'builder' ? handleWidgetHover : null}
      >
        <CardContent className={classes.header} >
          <Typography variant="h5" component="h2" className={classes.headerText} >
            {context.header_text[language]}
          </Typography>
        </CardContent>

        <CardContent classes={{ root: classes.roomResults }} >
          <List disablePadding >
            {context.rooms.map( (item, index) =>
            <ListItem key={index} disableGutters >
              {context.show_room_images &&
                <img src={item.room_img} className={classes.roomImg} />
              }
              <Box className={classes.middle}>
                <Typography variant="subtitle2" component="span" className="name">
                  {item.room_name}
                </Typography>
                <Typography variant="body2" component="p" className="date">
                  {item.room_time}
                </Typography>
              </Box>
              <Box className={classes.right}>
                {item.did_escape ? (
                  <>
                  <Typography variant="body1" component="span" className="time">

                    {item.ranking_metric == "Time Remaining" ? (
                      item.time_remaining ? item.time_remaining : "n/a"
                    ) : null }

                    {item.ranking_metric == "Points" ? (
                      item.points ? item.points.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : "n/a"
                    ) : null }

                    {item.ranking_metric == "Clues" ? (
                      item.clues ? item.clues : "n/a"
                    ) : null }
                    
                  </Typography>
                  <Typography variant="caption" component="p" className="time-label">
                    {item.ranking_value_label}
                  </Typography>
                  </>
                ) : (
                  <Typography variant="caption" component="p" className="failed">
                    {translate("Almost Escaped", language)}
                  </Typography>
                )}
              </Box>
            </ListItem>
            )}
          </List>
        </CardContent>

        {window.mode == 'builder' && showWidgetBar &&
          <WidgetBar context={context} />
        }

      </Card>
    }
    </>
  );
}

